import QuantityProduct from './QuantityProduct'

class PremiumHighPhotoProduct extends QuantityProduct {
  static MINIMUM_QUANTITY = 5
}

export default PremiumHighPhotoProduct
